"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Attribution;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _text = _interopRequireDefault(require("@ux/text"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
const AttributionContainer = "pl-a1km669j";
function Attribution({
  attribution,
  attributionHeadline,
  attributionDescription,
  formatLegacy
}) {
  if (attributionHeadline || attributionDescription) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _core.cx)(AttributionContainer, 'attribution-content')
    }, attributionHeadline && /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "title",
      className: "attribution-headline",
      size: -1
    }, attributionHeadline), attributionDescription && /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "paragraph",
      className: "attribution-description",
      size: -1
    }, attributionDescription));
  }
  if (attribution && typeof formatLegacy === 'function') {
    return formatLegacy();
  }
  return null;
}
Attribution.propTypes = {
  attribution: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string,
  formatLegacy: _propTypes.default.func
};